import { Component, ElementRef, OnInit, ViewChild, AfterViewChecked } from '@angular/core';
import { Router } from '@angular/router';
import { AgentService } from '@core/services/agent.service';
import { Observable } from 'rxjs';
import { AgentAction, AgentWidget } from '@shared/models/agent.model';

@Component({
    selector: 'app-agent-chat',
    templateUrl: './agent-chat.component.html',
    styleUrls: ['./agent-chat.component.scss']
})
export class AgentChatComponent implements OnInit, AfterViewChecked {
    @ViewChild('scrollContainer') private scrollContainer!: ElementRef;

    messages$!: Observable<any[]>;
    isLoading$!: Observable<boolean>;
    isOpen$!: Observable<boolean>;

    userInput: string = '';

    constructor(
        private agentService: AgentService,
        private router: Router
    ) { }

    ngOnInit(): void {
        this.messages$ = this.agentService.messages$;
        this.isLoading$ = this.agentService.isLoading$;
        this.isOpen$ = this.agentService.isOpen$;
    }

    ngAfterViewChecked() {
        this.scrollToBottom();
    }

    toggleChat() {
        this.agentService.toggleChat();
    }

    sendMessage() {
        if (!this.userInput.trim()) return;
        this.agentService.sendMessage(this.userInput);
        this.userInput = '';
    }

    onKeydown(event: KeyboardEvent) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.sendMessage();
        }
    }

    handleAction(action: AgentAction) {
        if (!action) return;

        switch (action.type) {
            case 'NAVIGATE':
                if (action.payload?.url) {
                    this.router.navigate([action.payload.url], { queryParams: action.payload.queryParams });
                }
                break;
            case 'OPEN_MODAL':
                // For now, specialized handling for TASK_DETAIL
                // We navigate to /task/list?openTaskId=... 
                // The receiving component needs to handle this.
                if (action.payload?.id) {
                    this.router.navigate(['/task/list'], { queryParams: { openTaskId: action.payload.id } });
                }
                break;
            case 'COPY_TEXT':
                if (action.payload?.text) {
                    navigator.clipboard.writeText(action.payload.text);
                    // Optional: show toast
                }
                break;
            case 'API_CALL':
                console.log('API_CALL action not yet implemented in frontend', action);
                break;
        }
    }

    onMessageClick(event: MouseEvent) {
        // Intercept link clicks within markdown
        const target = event.target as HTMLElement;
        if (target.tagName === 'A') {
            const href = target.getAttribute('href');
            if (href && href.startsWith('/')) {
                event.preventDefault();
                this.router.navigateByUrl(href);
            }
        }
    }

    private scrollToBottom(): void {
        try {
            this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
        } catch (err) { }
    }
}
